import { UserCivility, DealerType } from "../../account/constants/dealer-basic-data";
import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { CarJobTemplate } from "../../car/models/car-job-template.model";
import { CarJobCategory } from "../../keep/constants/keep-basic-data";

import { ServiceType, AppointmentLocationMode, AppointmentStatus } from "../constants/common-basic-data";
import { PhoneNumber } from "./address.model";
import { GeoIPLocation } from "./geo-ip-location.model";

export class Appointment {

    id: number = 0;
    businessLine: CarBusinessLine = CarBusinessLine.BUY;

    customerId: string = "";
    customerCivility: UserCivility = UserCivility.Mr;
    customerFirstName: string = "";
    customerLastName: string = "";

    customerDealerType: DealerType = DealerType.PERSONAL;
    customerBusinessName: string = "";

    customerEmail: string = "";
    customerPhoneNumber: PhoneNumber = new PhoneNumber();
    customerCity: string = "";
    customerCountry: string = "";
    //customer: Dealer = new Dealer();

    carId: string = "";
    offerId: string = "";
    carMake: string = "";
    carModel: string = "";
    carVersion: string = "";
    carYear: number = 0;
    //car: Car = new Car();

    providerId: string = "";
    providerName: string = "";
    providerBusinessName: string = "";
    //provider: Dealer = new Dealer();

    details: string = "";

    services: ServiceType [] = [];
    jobCategories: CarJobCategory [] = [];
    jobTemplates: CarJobTemplate [] = [];
    
    locationMode: AppointmentLocationMode = AppointmentLocationMode.SELLER_LOCATION;
    location: GeoIPLocation = new GeoIPLocation();
    city: string = '';
    country: string = '';
    
    appointmentDate: string = "";
    rescheduleDate: string = "";

    created: string = "";
    lastUpdated: string = "";

    needCallback: boolean = false;
    emergency: boolean = false;
    status: AppointmentStatus = AppointmentStatus.PROPOSED;

     constructor(){
         
     }
 }